export default __webpack_public_path__ + "static/media/producto_3.456939e5.png";